import { render, staticRenderFns } from "./modalTemplate.vue?vue&type=template&id=b72a5f3c&scoped=true&"
import script from "./modalTemplate.vue?vue&type=script&lang=js&"
export * from "./modalTemplate.vue?vue&type=script&lang=js&"
import style0 from "./modalTemplate.vue?vue&type=style&index=0&id=b72a5f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72a5f3c",
  null
  
)

export default component.exports